export default "__VITE_ASSET__DzOnI_rt__"